import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import VendorHistoryFilterModal from "./VendorHistoryFilterModal";
import { format, parse } from "date-fns";

const defaultFilterData = {
  vendorName: "",
  vendorId: "",
  txnsType: "",
  status: [],
  fromDate: "",
  toDate: "",
};

const VendorTxtHistory = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [sellSMSData, setSellSMSData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openModalFilter = () => {
    setIsFilterModalOpen(true);
  };

  const closeModalFilter = () => {
    setIsFilterModalOpen(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
    fetchSellSMSData(1, defaultFilterData);
  };

  // Function to format date from "year-month-day" to "day-month-year"
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    fetchSellSMSData(1, filterData);
  }, []);

  const fetchSellSMSData = async (pageNo, filters) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        vendorName: filters.vendorName || "",
        vendorId: filters.vendorId || "",
        txnsType: filters.txnsType || "",
        status: filters.status || [],
        fromDate: formatDate(filters.fromDate) || "",
        toDate: formatDate(filters.toDate) || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_SELLSMS_DATA}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setSellSMSData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setSellSMSData([]);
        if (
          response?.data?.respCode !== "01" &&
          response?.data?.data !== null
        ) {
          CustomAlert({
            title: "Failed to Fetch Data",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => {
      const formattedDate = item?.transactionDate
        ? parse(item.transactionDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      return {
        ...item,
        id: index + 1,
        transactionDate: formattedDate
          ? [
              format(formattedDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
  };

  const sellSMSHeaders = [
    "Status",
    "Vendor Id",
    "Vendor name",
    "Vendor old balance",
    "Vendor new balance",
    "Customer Id",
    "Customer Name",
    "Transaction Id",
    "TxnType",
    "Transaction Date",
    "Sms",
    "Customer Old Sms",
    "Customer New Sms",
    "Rate",
    "Amount",
  ];

  const sellSMSHeaderToKeyMap = {
    Status: "status",
    "Vendor Id": "vendorId",
    "Vendor name": "vendorName",
    "Vendor old balance": "vendorOldSms",
    "Vendor new balance": "vendorNewSms",
    "Customer Id": "customerId",
    "Customer Name": "customerName",
    "Transaction Id": "rrn",
    TxnType: "txnType",
    "Transaction Date": "transactionDate",
    Sms: "sms",
    "Customer Old Sms": "customerOldSms",
    "Customer New Sms": "customerNewSms",
    Rate: "rate",
    Amount: "amount",
  };

  const handlerSellSMS = (id, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else {
      let data = sellSMSData.find((item) => item.id === id);
      setEditData(data);
      setShowModal(true);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={sellSMSHeaders}
            data={sellSMSData}
            handleAction={handlerSellSMS}
            filterFields={["vendorName"]}
            entityType="Vendor Txt History"
            hideAction="hideAction"
            headerToKeyMap={sellSMSHeaderToKeyMap}
            loading={loading}
            pageDetails={pageDetails}
            noData={noData}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={(pageNo) => fetchSellSMSData(pageNo, filterData)}
            setCurrentPage={setCurrentPage}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            fetchData={() => {}}
            filterData={filterData}
          />
          {isFilterModalOpen && (
            <VendorHistoryFilterModal
              show={isFilterModalOpen}
              handleClose={closeModalFilter}
              setFilterData={setFilterData}
              filterData={filterData}
              handleReset={handleReset}
              setSellSMSData={setSellSMSData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              pageSize={pageSizeCount}
              currentPage={currentPage}
            />
          )}
        </>
      )}
    </div>
  );
};

export default VendorTxtHistory;
